<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card class="neu-glow pb-5 elevation-8">
          <v-card-title primary-title>
            <div class="text-h5">iManager</div>
            <v-spacer></v-spacer>
            <v-div>
              <!--            
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="items_hash==JSON.stringify(items)" @click.stop="saveItem()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
            </v-div>           
          </v-card-title>
          <div 
            ref="scrollContainer"
            class="scroll-container"
            :max-height="wHeight-200"
          >
            <v-row v-if="loading">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>
            <div v-else >
              <masonry-wall :items="classes"  scroll-container="scrollContainer" :gap="16" class="mx-4">
                <template #default="{ item }">
                  <v-card class="neu-glow my-3">
                    <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                      {{item}}
                    </v-card-title>
                    <v-row class="mx-2" v-for="(i,ii) in items.filter(i=>i.class==item)" :key="ii">
                      
                      <v-col cols="11" v-if="i.dataType=='nvarchar'" class="d-flex align-center">
                          <v-text-field   
                           
                            counter
                            :label="i.description"
                            outlined
                            :name="i.optionId"
                            @input.native="save"
                            :reverse="i.dataType!='nvarchar'"
                            v-model="i.value"
                            persistent-placeholder
                            hide-details
                            :readonly="!i.editableByUser"
                          >
                          </v-text-field>
                      </v-col>
                      <template v-else>
                        <v-col cols="8" class="d-flex align-center">
                          {{i.description}}
                        </v-col>
                        <v-col cols="3" class="d-flex align-center">
                          <template v-if="i.dataType=='bit'">
                            <v-switch
                              color="info"
                              
                              v-model="i.value"
                              inset
                              @change="save2($event, i.optionId)"
                              :label="i.value?'Si':'No'"
                              hide-details
                              :readonly="!i.editableByUser"
                              class="mt-0 pt-0"
                            ></v-switch>                      
                          </template>
                          <template v-else>
                            <v-text-field   
                              
                              counter
                              @input.native="save"
                              label=""
                              outlined
                              :name="i.optionId"
                              :reverse="i.dataType!='nvarchar'"
                              v-model="i.value"
                              persistent-placeholder
                              hide-details
                              :readonly="!i.editableByUser"
                            >
                            </v-text-field>                          
                          </template>
                        </v-col>
                      <v-col cols="1" class="d-flex align-center">
                        <v-tooltip max-width="250" top v-if="i.help||!i.editableByUser">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                          </template>
                          <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                        </v-tooltip>                          
                      </v-col>                                                
                    </v-row>
                  </v-card>
                </template>
              </masonry-wall>
            </div>
          </div>
        </v-card>
    </v-form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import { VueEditor  } from "vue2-editor";
import _ from 'lodash'
// mettere prima di data() =>components: { VueEditor },
//https://github.com/DerYeger/yeger/blob/main/docs/vue-masonry-wall-docs/src/app.vue
export default {
  
  data() {
    return {
      page: "Settings",
      dialog_edit:false,
      dialog_delete:false,
      dialog_instruction:false,
      loading:false,
      snackbar:false,
      snackbar_color:'success',
      snackbar_message:null,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      items_hash:null,
      items:[],
      editedItem:{name:"",sortOrder:null,icon:"",active:false},
      loading_refresh:false,
      classes:null,
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Descrizione',       value: 'description',  align: 'left',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Parametro',         value: 'parameter',    align: 'left',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Impostazione',      value: 'dataType',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Azione',      value: 'actions',                         sortable: false, class:'pl-1 text-lg-button' },
                /*,
                { text: 'ID',           value: 'optionId',      align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Tipo',         value: 'dataType',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Icona WA',     value: 'waIcon',        align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Attiva',       value: 'active',        align: 'center',  sortable: false, class:'px-1 text-lg-button' },*/
              ],      
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        //[{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
      ],      
     
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
  },
  methods:
  {
    save: _.debounce(function (event) {
      console.log(400,event.target.name,event.target.value)
      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var pload={"optionId":event.target.name,"value":value};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(406,payload)
      this.updateDB(payload)
    }, 1000),
    save2(value, field) {
      console.log(410,value, field);
      var pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(413,payload)
      this.updateDB(payload)
    },     
    editItem(f)
    {
      this.editedItem=f;
      console.log(214,f)
      this.dialog_edit=true;
    },
    deleteItem(f)
    {
      this.editedItem=f;
      console.log(214,f)
      this.dialog_delete=true;
    },    
    async saveItem()
    {
        console.log(144,this.editedItem);
        this.loading_update=true;
        console.log(255,this.form);
        var options=this.items.map(({ optionId, value }) => ({ optionId, value:value===false?0:value===true?1:value===''?null:value }));
        var action='saveItem';
        let payload={"action":action,"table":"AllOptions","payload":JSON.stringify(options)}
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;

        }   
    },

    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"action":"Options_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.items=res.data.payloads.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); return o});
                    this.items_hash=JSON.stringify(this.items);
                    this.classes=[...new Set( this.items.map(obj => obj.class)) ];
                    //this.items==Object.entries(settings).map(([key, value]) => ({key,value}));
                    console.log(315,this.items,res.data.payloads)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>
<style scoped>
.scroll-container {
  overflow-y: auto;
}
</style>